import { Link } from 'react-router-dom';
import "./InternetServices.css";
import { jwtDecode } from 'jwt-decode';
export const InternetServices = () => {
	const authToken = localStorage.getItem('authorizationToken') as string;
	const claims: any = jwtDecode(authToken);
	const partner = claims.partner;
	const managedWifi = partner.managedWifi;
	const dpskWifi = partner.dpskWifi;
	const wifiBaseplan = partner.wifiBaseplan;
	
    if (managedWifi || dpskWifi) {
		const wifiBundle = localStorage.getItem('wifiBundle') ? JSON.parse(localStorage.getItem('wifiBundle') as string) : null;
        const product = wifiBundle?.Product;
        // const globalContent = JSON.parse(localStorage.getItem('globalContent') as string);
        // const grid = globalContent.upgrade.grid;
        // let newThumbnailUrl = product.ThumbnailUrl.replace('/resources/images/common/', '/library/images/common/');
        return (
			<div className="internet-services-container" >
				<h1 className="internet-services-title">Speeds and Prices</h1>
				<div className="internet-services-cards" >
					{wifiBaseplan && (
						<div className="content-wrapper c1-wrapper" >
							<img className="internet-services-wifi-logo" alt="wifi logo" src="/library/images/wifi/wifi_logo.png" data-cookiecategory="1210" />
							<h1>{wifiBaseplan}</h1>
							<p className="c1-wrapper-header">Included at no extra cost</p>
							<Link to={`/account?tab=wifi`} className="btn-primary internet-services-btn">
                                    Get connected
							</Link>
						</div>
					)}
                    {product?.PricingPlans?.map((pricingPlan: any, index: number) => {
                        return (
                            <div key={index} className="content-wrapper c1-wrapper" >
								<img className="internet-services-wifi-logo" alt="wifi logo" src="/library/images/wifi/wifi_logo.png" data-cookiecategory="1210" />
                                <h1>{pricingPlan.Name}</h1>
                                <p className="c1-wrapper-header">{pricingPlan.chargeAmountLabel}</p>
								<Link to={`/wifiproduct?productId=${product.Id}&planId=${pricingPlan.Id}`} className="btn-primary internet-services-btn" aria-label="600 Mbps">
                                    Upgrade speed
                                </Link>
                            </div>
                        )
                    })}
                    <div className="clear"></div>
                </div>
                <p className="wifiFaq">
                        If you previously purchased an upgrade and would like to make a change to an alternate speed,<br />
                        you will need to first cancel your current speed subscription.  Please visit <Link to="/help">WiFi FAQ</Link>.
                </p>
            </div>
        );
    } else {
        return null;
    }
}